import React from "react";
import { Typography, Row, Col } from "antd";
import { useNavigate } from "react-router-dom";

import g1 from "../../assets/g1.jpg";
import g2 from "../../assets/g2.jpg";
import g4 from "../../assets/g4.jpg";
import g5 from "../../assets/g5.jpg";

const { Title, Text } = Typography;

const ViewGallery = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        padding: "40px 20px",
        background: "#f9f9f9",
        minHeight: "100vh",
      }}
    >
      {/* Header */}
      <div style={{ display: "flex", alignItems: "center", marginBottom: 30 }}>
        <span
          style={{
            fontSize: 24,
            fontWeight: "bold",
            cursor: "pointer",
          }}
          onClick={() => navigate(-1)}
        >
          &lt;
        </span>
        <Text strong style={{ fontSize: 16, marginLeft: 8 }}>
          All Gallery
        </Text>
      </div>

      {/* Title Section */}
      <div style={{ textAlign: "center", marginBottom: 50 }}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: 12,
            marginBottom: 10,
          }}
        >
          {/* NEWS box */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              background: "#ED1C2417",
              padding: "4px 12px",
              borderRadius: 3,
              position: "relative",
            }}
          >
            <div
              style={{
                width: 6,
                height: "100%",
                background: "#ED1C24",
                position: "absolute",
                left: 0,
                top: 0,
                bottom: 0,
                borderRadius: 2,
              }}
            ></div>

            <Text
              style={{
                fontSize: 12,
                fontWeight: 600,
                color: "#000",
                marginLeft: 8,
              }}
            >
              NEWS
            </Text>
          </div>

          <Text style={{ color: "#888", fontSize: 12 }}>10 PHOTOS</Text>
        </div>

        {/* Title */}
        <Title level={2} style={{ fontWeight: 700, marginBottom: 6 }}>
          DUBAI Street Tournaments - Sept 2025
        </Title>

        {/* Date */}
        <Text style={{ color: "#555", fontSize: 13 }}>THU 24 SEP 2025</Text>
      </div>

      {/* Images Grid */}
      <div style={{ maxWidth: 1200, margin: "0 auto" }}>
        {/* Top Row */}
        <Row gutter={[12, 12]} justify="center">
          <Col xs={24} sm={12}>
            <img
              src={g4}
              alt="gallery-top-1"
              style={{
                width: "100%",
                height: 280,
                objectFit: "cover",
                borderRadius: 0,
              }}
            />
          </Col>
          <Col xs={24} sm={12}>
            <img
              src={g5}
              alt="gallery-top-2"
              style={{
                width: "100%",
                height: 280,
                objectFit: "cover",
                borderRadius: 0,
              }}
            />
          </Col>
        </Row>

        {/* Bottom Row */}
        <Row gutter={[12, 12]} justify="center" style={{ marginTop: 30 }}>
          <Col xs={24} sm={12}>
            <img
              src={g1}
              alt="gallery-bottom-1"
              style={{
                width: "100%",
                height: "auto",
                maxHeight: 550,
                objectFit: "cover",
                borderRadius: 0,
                display: "block",
              }}
            />
          </Col>
          <Col xs={24} sm={12}>
            <img
              src={g2}
              alt="gallery-bottom-2"
              style={{
                width: "100%",
                height: "auto",
                maxHeight: 550,
                objectFit: "cover",
                borderRadius: 0,
                display: "block",
              }}
            />
          </Col>
        </Row>

        {/* Text and Button Below Images */}
        <div style={{ textAlign: "center", marginTop: 40 }}>
          <Text
            style={{
              fontSize: 18,
              fontWeight: 600,
              color: "#000",
              letterSpacing: 0.5,
              display: "block",
              marginBottom: 20,
            }}
          >
            Want to feature your Yalla Nellab moments?
          </Text>

          <button
            style={{
              background: "#480558",
              color: "#fff",
              border: "none",
              padding: "12px 28px",
              borderRadius: 6,
              fontSize: 16,
              fontWeight: 600,
              cursor: "pointer",
              transition: "all 0.3s ease",
            }}
            onClick={() => alert("Upload your moment clicked!")}
          >
            Upload Your Moments
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewGallery;
